<script setup>
import DropDownMenu from '@/components/Atoms/DropDownMenu.vue'

/** "⌨ Shortcuts" text link (under the transition rail) opening a compact card of the control-room hotkeys. */
defineProps({
	position: { type: String, default: 'left' },
})

const KEYS = [
	{ keys: ['1', '–', '9'], label: 'Scene → Preview' },
	{ keys: ['Space', '/', 'Enter'], label: 'Send to live' },
	{ keys: ['⇧', '1', '–', '9'], label: 'Graphic on / off' },
	{ keys: ['B'], label: 'End running break' },
	{ keys: ['⌘', 'Z'], label: 'Undo layout change' },
	{ keys: ['⌘', 'Enter'], label: 'Apply layout to live' },
	{ keys: ['⌥', '+ drag'], label: 'Move past the canvas edge' },
]
</script>

<template>
	<DropDownMenu
		type="custom"
		size="sm"
		:position="position"
		use-teleport
		max-height="none"
		aria-label="Keyboard shortcuts"
		list-width="w-[260px] max-w-[calc(100vw-16px)]"
		list-classes="px-1 py-1.5"
		custom-classes="inline-flex h-7 items-center gap-1.5 rounded px-1.5 text-xs font-medium text-surface-7 transition-colors hover:text-white focus:outline-none focus-visible:text-white focus-visible:ring-2 focus-visible:ring-main"
		data-testid="shortcuts-toggle"
	>
		<template #toggle-button>
			<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true">
				<rect x="2.5" y="6" width="19" height="12" rx="2" />
				<path d="M6 10h.01M9.5 10h.01M13 10h.01M16.5 10h.01M6.5 14h11" />
			</svg>
			<span>Shortcuts</span>
		</template>
		<template #menu-items>
			<li class="px-2 pb-1 text-[0.65rem] font-semibold uppercase tracking-wider text-surface-6">Keyboard shortcuts</li>
			<li v-for="row in KEYS" :key="row.label" class="flex items-center justify-between gap-3 px-2 py-[3px] text-xs text-surface-text-1" data-testid="shortcut-row">
				<span class="min-w-0 truncate">{{ row.label }}</span>
				<span class="flex shrink-0 items-center gap-0.5">
					<template v-for="(k, i) in row.keys" :key="i">
						<span v-if="k === '–' || k === '/' || k.startsWith('+')" class="px-0.5 text-[0.65rem] text-surface-7">{{ k }}</span>
						<kbd v-else class="min-w-[18px] rounded bg-surface-4 px-1 py-px text-center font-mono text-[0.65rem] leading-4 text-white">{{ k }}</kbd>
					</template>
				</span>
			</li>
		</template>
	</DropDownMenu>
</template>
